import { WMItemKitHeaderDpLookupLayout } from "../../../../common/lookups/Layouts/WMLayouts";
import { IDCustomerLookupLayout } from "../../../../common/lookups/Layouts/IdLayouts";

// Search panel for the WM Item Kit Codes find screen - four groups, matching the sibling
// data-profile screens.
export const SearchLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "recordNumber",
                "tableName": "IMITEMKITTHEADER",
                "localizedField": "Keysequence",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "kittCode",
                "tableName": "IMITEMKITTHEADER",
                "label": "Kit Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            {
                "name": "description",
                "tableName": "IMITEMKITTHEADER",
                "label": "Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            {
                "name": "profileCode",
                "tableName": "IMITEMKITTHEADER",
                "label": "Profile Code",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            {
                "name": "profileDescription",
                "tableName": "IMITEMKITTHEADER",
                "label": "Profile Description",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            }
        ]
    }
];

export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RECORD",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IMITEMKITTHEADER",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "readOnly": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_PROFILE",
                "tableName": "IMITEMKITTHEADER",
                "label": "Profile",
                "type": "lookup",
                "layout": WMItemKitHeaderDpLookupLayout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "R_CUSTOMER",
                "tableName": "IMITEMKITTHEADER",
                "label": "Customer",
                "type": "lookup",
                "layout": IDCustomerLookupLayout(),
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "KITTCODE",
                "tableName": "IMITEMKITTHEADER",
                "label": "Kit Code",
                "type": "text",
                "required": true,
                "maxLength": 30,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "DESCRIPTION",
                "tableName": "IMITEMKITTHEADER",
                "label": "Description",
                "type": "text",
                "maxLength": 40,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "STATUS",
                "tableName": "IMITEMKITTHEADER",
                "label": "Status",
                "type": "select",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "COMMENT",
                "tableName": "IMITEMKITTHEADER",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            
        ]
    }
];

